<template>
  <div>
    <el-carousel height="2.9rem" :autoplay="true" :interval="5000">
      <el-carousel-item>
        <img
          src="../../assets/images/banner/about/1.jpg"
          width="100%"
          height="100%"
        />
      </el-carousel-item>
      <el-carousel-item>
        <img
          src="../../assets/images/banner/about/2.jpg"
          width="100%"
          height="100%"
        />
      </el-carousel-item>
    </el-carousel>
    <div class="box2">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
      >
        <el-menu-item index="1">公司简介</el-menu-item>
        <el-menu-item index="2" @click="menuClick(2)">发展历程</el-menu-item>
        <!-- <el-menu-item index="3"
          @click="menuClick(3)">发展态势</el-menu-item> -->
        <el-menu-item index="4" @click="menuClick(4)">发展目标</el-menu-item>
        <el-menu-item index="5" @click="menuClick(5)">企业使命</el-menu-item>
        <el-menu-item index="6" @click="menuClick(6)">新闻中心</el-menu-item>
        <el-menu-item index="7" @click="menuClick(7)">荣誉资质</el-menu-item>
      </el-menu>
    </div>
    <div class="box3">
      <div class="main">
        <div class="tit">
          <img src="../../assets/images/home/logo.png" />
          深圳市九象数字科技有限公司
        </div>
        <p style="margin: 0.42rem 0 0.22rem">
          深圳市九象数字科技有限公司是一家专业从事智慧工地整体解决方案、智慧工地软硬件产品研发与制造，智慧安全产品研发、安全教育展厅、智慧建造展馆、工程动画视频制作等特色服务，为建筑业提供数字施工、智慧建造等整体打包服务的国家高新技术企业。
        </p>
        <p>
          公司现有员工200余人，目前已经成立长沙公司、成都公司、上海公司、广州公司、武汉公司、重庆公司，即将成立北京公司。客户主要为中国建筑、中国中铁、中国铁建、中国交建、中国中冶、中国电建、碧桂园、万科、恒大、各地省建工、住建局等知名企业。
        </p>
      </div>
      <div class="pto">
        <el-carousel height="3rem" :autoplay="true" :interval="5000">
          <el-carousel-item>
            <img
              src="../../assets/images/introduction-new/1.jpg"
              width="100%"
              height="100%"
            />
          </el-carousel-item>
          <el-carousel-item>
            <img
              src="../../assets/images/introduction-new/2.jpg"
              width="100%"
              height="100%"
            />
          </el-carousel-item>
          <el-carousel-item>
            <img
              src="../../assets/images/introduction-new/3.jpg"
              width="100%"
              height="100%"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="box4" id="box4">
      <div class="main2">
        <!-- <div style="margin-top:1.13rem;">
                    <div class="min">
                        <div>
                            成为中国建筑、中铁、中国铁建、万科、华为、富士康等知名企业供应商，标志着九象实力得到高端客户的认可。
                        </div>
                        <img src="../../assets/images/about/brief/lc2.jpg" width="100%"/>
                        <div class="lin"></div>
                    </div>
                    <div class="min" style="margin-top:.63rem">
                        <div>
                            智慧工地2.0、VR安全体验4.0等一系列产品正式上线，标志着九象从单一服务商转型为全产业链的数字技术服务商。
                        </div>
                        <img src="../../assets/images/about/brief/lc4.jpg" width="100%"/>
                        <div class="lin"></div>
                    </div>
                </div> -->
        <!-- <div class="cen">
                    <p>2005</p>
                    <div class="ran"></div>
                    <div class="line"></div>
                    <p>2007</p>
                    <p>2008</p>
                    <div class="line hei"></div>
                    <p>2009</p>
                    <p>2017</p>
                    <div class="line hei2"></div>
                    <p>2018</p>
                    <p>2019</p>
                    <div class="line hei3"></div>
                </div> -->
        <!-- <div>
                    <div class="min" style="height: 2.52rem">
                        <div>
                            参与制作《CCTV新台址大楼》建筑施工投标陈述动画。
                        </div>
                        <img src="../../assets/images/about/brief/lc1.jpg" width="100%"/>
                        <div class="lin site"></div>
                    </div>
                    <div class="min">
                        <div>
                            九象的客户已遍布全国30个省、100多个城市，为客户提供全面的视效创意与BIM应用整体解决方案。
                        </div>
                        <img src="../../assets/images/about/brief/lc3.jpg" width="100%"/>
                        <div class="lin site"></div>
                    </div>
                </div> -->
      </div>
    </div>
    <div class="box9" id="box9">
      <!--            <div class="tit">发展态势</div>-->
      <!--            <div class="bor"></div>-->
      <!-- <div class="main">
        <img src="../../assets/images/about/brief/fzts.jpg"
          style="width: 100%;height: auto" /> -->
      <!--                <div class='text'>-->
      <!--                    <p>近5年来，公司经营业绩均保持50%以上的增长；</p>-->
      <!--                    <p>2018年 新签合同额 同比增长150%；</p>-->
      <!--                    <p>2019年 新签合同额 同比增长50%；</p>-->
      <!--                    <p>2020年 新签合同额 同比增长88%；</p>-->
      <!--                    <p>2021年 预计新签合同额同比增长90%；</p>-->
      <!--                </div>-->
      <!-- </div> -->
    </div>
    <div class="box10" id="box10">
      <div class="tit">发展目标</div>
      <div class="bor"></div>
      <div class="main">
        <div>
          <p>至2024年，公司营销网点覆盖全国中心城市。</p>
          <p>未来2-3年，三大产品成为行业细分领域第一。</p>
          <p>未来4-6年，迈入中国A股公众上市公司队列。</p>
        </div>
      </div>
    </div>
    <div class="box5" id="box6">
      <div class="tit">企业使命</div>
      <div class="bor"></div>
    </div>
    <div class="box6">
      <div class="mina">
        <div class="lef">企业使命</div>
        <div class="rit">为了工程建设者的安全与效率</div>
      </div>
      <div class="mina">
        <div
          class="lef"
          style="display: flex; align-items: center; justify-content: center"
        >
          企业愿景
        </div>
        <div class="rit">
          <p>服务1亿工程建设者</p>
          <p>成就客户，成就员工</p>
        </div>
      </div>
      <div class="mina">
        <div
          class="lef"
          style="display: flex; align-items: center; justify-content: center"
        >
          核心价值观
        </div>
        <div class="rit">
          <p>正直，诚信</p>
          <p>注解：以德为先，坚守底线。坦诚相待，言而有信。</p>
          <p>进取，激情</p>
          <p>注解：追求梦想，超越自我。满怀激情，永存斗志。</p>
          <p>责任，担当</p>
          <p>注解：敬业爱岗，责任心强。不畏难事，勇于担当。</p>
          <p>专注，创新</p>
          <p>注解：立足使命，聚焦专长。敢于创造，引领未来。</p>
        </div>
      </div>
    </div>
    <div class="box7" id="box7">
      <div class="box5">
        <div class="tit">新闻中心</div>
        <div class="bor"></div>
      </div>
      <div class="min">
        <div
          class="bot"
          v-for="(item, index) in newsList"
          :key="index"
          v-if="index < 6"
          :class="index % 2 === 0 ? '' : 'mar'"
          @click="newsClick(index)"
        >
          <div style="display: flex">
            <div class="le">
              <p class="p1">{{ item.day }}</p>
              <p class="p2"></p>
              <p class="p3">{{ item.year }}-{{ item.month }}</p>
            </div>
            <p class="ri">{{ item.titleSmall }}</p>
          </div>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div style="clear: both"></div>
      </div>
      <div class="news_more" @click="goList">
        查看更多 <i class="el-icon-arrow-right"></i>
      </div>
    </div>

    <div class="box5" id="box8">
      <div class="tit">荣誉资质</div>
      <div class="bor"></div>
    </div>
    <div class="box8">
      <!--            <el-carousel height="1.9rem">-->
      <!--                <el-carousel-item v-for="item in 1" :key="item">-->
      <!--                    -->
      <!--                </el-carousel-item>-->
      <!--            </el-carousel>-->
      <div class="main3">
        <img src="../../assets/images/about/new/1.png" />
        <img src="../../assets/images/about/2.png" />
        <img src="../../assets/images/about/new/2.jpg" />
        <img src="../../assets/images/about/new/3.png" />
        <img src="../../assets/images/about/13.png" />
      </div>
      <div class="main4">
        <img src="../../assets/images/about/3.jpg" />
        <img src="../../assets/images/about/4.jpg" />
        <img src="../../assets/images/about/5.jpg" />
        <img src="../../assets/images/about/6.jpg" />
        <img src="../../assets/images/about/7.png" />
      </div>
      <div class="main4">
        <img src="../../assets/images/about/10.jpg" />
        <img src="../../assets/images/about/8.jpg" />
        <img src="../../assets/images/about/9.jpg" />
        <img src="../../assets/images/about/12.jpg" />
        <img src="../../assets/images/about/11.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Introduction',
  provide() {
    return {
      reload: this.reload,
    }
  },
  data() {
    return {
      newsList: [],
      activeIndex: '1',
      top: 0,
      timer: '',
      num: 0,
    }
  },
  methods: {
    menuClick(evn) {
      switch (evn) {
        case 1:
          this.top = 0
          this.num = 0
          break
        case 2:
          this.top = document.getElementById('box4').offsetTop
          this.num = 0
          break
        case 3:
          this.top = document.getElementById('box9').offsetTop
          this.num = 0
          break
        case 4:
          this.top = document.getElementById('box10').offsetTop
          this.num = 0
          break
        case 5:
          this.top = document.getElementById('box6').offsetTop
          this.num = 0
          break
        case 6:
          this.top = document.getElementById('box7').offsetTop
          this.num = 0
          break
        case 7:
          this.top = document.getElementById('box8').offsetTop
          this.num = 0
          break
      }
      this.top = this.top - 120
      let distanc =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      if (distanc < this.top) {
        window.scrollBy(0, this.top)
      } else {
        window.scrollBy(0, this.top)
      }
    },
    newsClick(index) {
      this.$router.push({
        path: 'new',
        query: {
          page: index,
        },
      })
      document.documentElement.scrollTop = 0
    },
    //滚动条在Y轴上的滚动距离
    getScrollTop() {
      let scrollTop = 0,
        bodyScrollTop = 0,
        documentScrollTop = 0
      if (document.body) {
        bodyScrollTop = document.body.scrollTop
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop
      }
      scrollTop =
        bodyScrollTop - documentScrollTop > 0
          ? bodyScrollTop
          : documentScrollTop
      return scrollTop
    },

    //文档的总高度
    getScrollHeight() {
      let scrollHeight = 0,
        bodyScrollHeight = 0,
        documentScrollHeight = 0
      if (document.body) {
        bodyScrollHeight = document.body.scrollHeight
      }
      if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight
      }
      scrollHeight =
        bodyScrollHeight - documentScrollHeight > 0
          ? bodyScrollHeight
          : documentScrollHeight
      return scrollHeight
    },

    //浏览器视口的高度
    getWindowHeight() {
      let windowHeight = 0
      if (document.compatMode == 'CSS1Compat') {
        windowHeight = document.documentElement.clientHeight
      } else {
        windowHeight = document.body.clientHeight
      }
      return windowHeight
    },
    handleScroll: function () {
      if (this.num === 5) {
        if (
          this.getScrollTop() + this.getWindowHeight() ==
          this.getScrollHeight()
        ) {
          clearInterval(this.timer)
        }
      } else {
        let distanc =
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          window.pageYOffset
        if (distanc > this.top) {
          clearInterval(this.timer)
        }
      }
    },
    goList() {
      this.$router.push('news-list')
      document.documentElement.scrollTop = 0
    },
  },
  mounted() {
    let key = this.$route.params.key
    if (key) {
      this.menuClick(key)
    }
    this.newsList = this.$newsList.concat()
    this.newsList.sort((a, b) => b.num - a.num)
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
}
</script>

<style lang="scss" scoped>
.news_more {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.18rem;
  cursor: pointer;

  &:hover {
    color: #e70f20;

    i {
      color: #e70f20;
    }
  }

  i {
    font-size: 0.22rem;
    color: #b5b5b5;
  }
}

.box {
  height: 2.9rem;
  width: 100%;
  background: url('../../assets/images/about/brief/jx.jpg');
  background-size: 100% 100%;
}

.box2 {
  width: 12rem;
  margin: 0.34rem auto;
  text-align: center;

  .el-menu-item {
    width: 1.65rem;
    font-size: 0.2rem;
    height: 0.72rem;
    line-height: 0.72rem;
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 3px solid #e70f20;
    color: #e70f20;
  }

  .el-menu--horizontal > .el-menu-item {
    color: #000;
  }
}

.box3 {
  width: 12rem;
  margin: 0.6rem auto;
  position: relative;

  .main {
    width: 9.8rem;
    height: 4.8rem;
    background: #f9f9f9;
    padding: 0.6rem 0 0 0.6rem;

    .tit {
      line-height: 0.47rem;
      font-size: 0.24rem;
      color: #3f3f3f;

      img {
        width: 1.22rem;
        height: 0.47rem;
        vertical-align: middle;
        margin-right: 0.45rem;
      }
    }

    p {
      width: 5.8rem;
      font-size: 0.18rem;
      color: #595757;
      line-height: 0.36rem;
      text-align: justify;
    }
  }

  .pto {
    width: 4.7rem;
    height: 3rem;
    margin-left: 0.88rem;
    position: absolute;
    right: 0;
    top: 0.65rem;
  }
}

.box4 {
  height: 7.2rem;
  width: 100%;
  background: url('../../assets/images/about/brief/fzlc.jpg');
  background-size: 100% 100%;

  .main2 {
    width: 9.3rem;
    margin: 0 auto;
    display: flex;

    .min {
      width: 4rem;
      height: 2.86rem;
      background: #fff;
      padding: 0.17rem 0.27rem 0.19rem;
      line-height: 0.3rem;
      font-size: 0.18rem;
      color: #595757;
      border: 1px solid #eee;
      margin-bottom: 0.56rem;
      position: relative;

      img {
        margin-top: 0.15rem;
        height: 1.4rem;
        width: 100%;
      }

      .lin {
        position: absolute;
        background: #d2d2d2;
        width: 0.28rem;
        height: 1px;
        top: 0.1rem;
        right: -0.34rem;
      }

      .site {
        left: -0.34rem;
      }
    }

    .cen {
      font-size: 0.23rem;
      text-align: center;
      margin: 0 0.38rem;

      p {
        line-height: 0.3rem;
        font-family: 'SourceHanSansSC-Regular';
      }

      .ran {
        width: 0.18rem;
        height: 0.18rem;
        border: 2px solid #e70f20;
        border-radius: 100%;
        margin: 0 auto;
      }

      .line {
        display: inline-block;
        width: 2px;
        background: #e70f20;
        height: 0.57rem;
      }

      .hei {
        height: 1.3rem;
      }

      .hei2 {
        height: 0.9rem;
      }

      .hei3 {
        height: 2.24rem;
      }
    }
  }
}

.box5 {
  text-align: center;
  padding-top: 0.44rem;

  .tit {
    font-size: 0.4rem;
  }

  .bor {
    width: 1rem;
    height: 2px;
    background: #e70f20;
    margin: 0.27rem auto 0.46rem;
  }
}

.box6 {
  width: 10.2rem;
  margin: 0 auto;
  font-size: 0.2rem;

  .mina {
    display: flex;
    width: 100%;
    line-height: 0.5rem;
    border: 1px solid #eee;
    margin-bottom: 0.25rem;

    .lef {
      width: 2.2rem;
      text-align: center;
      font-size: 0.22rem;
      border-right: 1px solid #eee;
      background: #f9f9f9;
    }

    .rit {
      padding-left: 0.4rem;
    }
  }
}

.box7 {
  height: 7.5rem;
  background: #f9f9f9;
  margin-top: 0.7rem;

  .min {
    width: 9.93rem;
    margin: 0 auto;

    .bot {
      border: 1px solid #eee;
      margin: 0 0.5rem 0.34rem 0;
      height: 1.4rem;
      padding-top: 0.25rem;
      width: 4.7rem;
      background: #fff;
      position: relative;
      float: left;
      cursor: pointer;

      .p1 {
        font-size: 0.3rem;
      }

      .p2 {
        width: 0.3rem;
        height: 1px;
        background: #e70f20;
        margin-top: 0.03rem;
      }

      .p3 {
        font-size: 0.14rem;
        color: #939393;
        line-height: 0.4rem;
      }

      .le {
        padding: 0.15rem 0 0 0.42rem;
        width: 1.24rem;
      }

      .ri {
        width: 3.44rem;
        height: 0.88rem;
        font-size: 0.2rem;
        text-align: justify;
        border-left: 1px solid #eaeaea;
        padding: 0.08rem 0.35rem 0 0.3rem;
      }

      i {
        position: absolute;
        bottom: 0.08rem;
        right: 0.07rem;
        font-size: 0.26rem;
        color: #b5b5b5;
      }
    }

    div.mar {
      margin-right: 0;
    }
  }
}

.box8 {
  width: 13.15rem;
  margin: 0 auto;

  .main3 {
    width: 13.15rem;
    margin: 0 auto;
    display: flex;

    img {
      width: 2.5rem;
      height: 1.89rem;
      margin: 0 0.06rem;
    }
  }

  .main4 {
    width: 13.15rem;
    margin: 0.2rem auto;
    display: flex;

    img {
      width: 2.5rem;
      height: 3.5rem;
      margin: 0 0.06rem;
    }
  }
}
.box9 {
  text-align: center;
  padding-top: 0.6rem;

  .tit {
    font-size: 0.4rem;
  }

  .bor {
    width: 1rem;
    height: 2px;
    background: #e70f20;
    margin: 0.27rem auto 0.46rem;
  }

  .main {
    display: flex;
    justify-content: center;

    .text {
      margin-top: 0.2rem;
      margin-left: 0.1rem;
      p {
        text-align: left;
        line-height: 0.45rem;
        font-size: 0.22rem;
      }
    }
  }
}

.box10 {
  margin-top: 0.2rem;
  @extend .box9;
  height: 5rem;
  background: url('../../assets/images/about/brief/fzmb.jpg') center center;
  background-size: 100% 100%;
  .main {
    text-align: left;

    p {
      font-size: 0.22rem;
      line-height: 0.4rem;
    }
  }
}
</style>
